module.exports = __webpack_public_path__ + "img/captain-s.7e7301d8.png";